@let extraItems = extraItems$ | async;


<div class="container govuk-width-container">
  <div class="row">
    <nav class="col-12 col-md-4" aria-label="Side navigation">
      <div class="h-100"><app-menu></app-menu></div>
    </nav>
    <main class="govuk-main-wrapper col-12 col-md-8" id="main-content" tabindex="-1">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="govuk-heading-xl">Enhancements</h1>
        </div>
      </div>
      <div class="row">
        @if(extraItems && extraItems.length > 0) {
          @for( item of extraItems; track $index) {
            <div class="col-sm-12">
              <app-enhancement-item [enhancement]="item"></app-enhancement-item>
            </div>
          }
        }
      </div>
    </main>
  </div>
</div>
